import { render } from "./PopupBottom.vue?vue&type=template&id=26173331"
import script from "./PopupBottom.vue?vue&type=script&lang=js"
export * from "./PopupBottom.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__